export class Constants {

    public static readonly conditions = [
        { id: 'AF', name: 'Atrial Fibrilation', codes: ['AF'] },
        { id: 'HYP', name: 'Hypertension', codes: ['HYP', 'CHD', 'STRK'] },
        { id: 'FH', name: 'Familial Hypercholesterolaemia', codes: ['FH'] },
        { id: 'CHOL', name: 'Cholesterol', codes: ['CHOL'] },
        { id: 'CKD', name: 'Chronic Kidney Disease', codes: ['CKD'] },
        { id: 'CVD', name: 'Cardiovascular Disease', codes: ['CVD']},
        { id: 'CVKM', name: 'Cardiovascular and Kidney Metabolic', codes: ['CVKM']},
        { id: 'SMOK', name: 'Smoking', codes: ['SMOK'] },
        { id: 'DM/NDH', name: 'Diabetes', codes: ['DM','NDH'] },
        { id: 'BMI', name: 'Body Mass Index', codes: ['BMI'] },
        { id: 'HF', name: 'Heart Failure', codes: ['HF'] }
    ]

    public static readonly OutcomesConditions = [
        { id: 'MORT', name: 'Mortality', codes: ['MORT'] },
        { id: 'ADMN', name: 'Admissions', codes: ['ADMN'] }
    ]

    public static readonly geographicalRelationships = [
        {
            systemLevelId: 1,
            systemLevelName: 'England',
            parentSystemLevelName: null,
            childSystemLevelName: 'STP',
            siblingWording: null,
            childWording: 'for all STPs in England'
        },
        {
            systemLevelId: 2,
            systemLevelName: 'STP',
            parentSystemLevelName: 'England',
            childSystemLevelName: 'CCG',
            siblingWording: 'for STPs in the same region as selected STP',
            childWording: 'for CCGs within selected STP'
        },
        {
            systemLevelId: 3,
            systemLevelName: 'CCG',
            parentSystemLevelName: 'STP',
            childSystemLevelName: 'PCN',
            siblingWording: 'for CCGs in the same STP as selected CCG',
            childWording: 'for PCNs within selected CCG'
        },
        {
            systemLevelId: 4,
            systemLevelName: 'PCN',
            parentSystemLevelName: 'CCG',
            childSystemLevelName: 'Practice',
            siblingWording: 'for PCNs in the same CCG as selected PCN',
            childWording: 'for Practices within selected PCN'
        },
        {
            systemLevelId: 5,
            systemLevelName: 'Practice',
            parentSystemLevelName: 'PCN',
            childSystemLevelName: null,
            siblingWording: 'for Practices in the same PCN as selected Practice',
            childWording: null
        },
        {
            systemLevelId: 6,
            systemLevelName: 'Region',
            parentSystemLevelName: 'England',
            childSystemLevelName: 'STP/ICB',
            siblingWording: 'for Regions within England',
            childWording: 'for STPs/ICBs within selected Region'
        },
        {
            systemLevelId: 7,
            systemLevelName: 'ICB',
            parentSystemLevelName: 'Region',
            childSystemLevelName: 'Sub-ICB',
            siblingWording: 'for ICBs in the same region as selected ICB',
            childWording: 'for sub-ICBs within selected ICB'
        },
        {
            systemLevelId: 8,
            systemLevelName: 'Sub-ICB',
            parentSystemLevelName: 'ICB',
            childSystemLevelName: 'PCN',
            siblingWording: 'for sub-ICBs in the same ICB as selected sub-ICB',
            childWording: 'for PCNs within selected sub-ICB'
        },
        {
            systemLevelId: 9,
            systemLevelName: 'England',
            parentSystemLevelName: null,
            childSystemLevelName: 'Region',
            siblingWording: null,
            childWording: 'for all Regions in England'
        },
    ]

    public static readonly brandColours = {
        primaryBlue: '#1458AA',
        secondaryBlue: '#669CCC',
        primaryPurple: '#6B3D85',
        secondaryPurple: '#A68CB5',
        primaryPink: '#B52666',
        secondaryPink: '#D47DA3',
        Persons: '#1458AA',
        Male: '#6B3D85',
        Female: '#B52666'
    }

    // The exact ValueNote text the API returns for a row suppressed for disclosure
    // control, as opposed to one that's simply missing or zero. Matched verbatim
    // against app-suppressed-value-flag's input, so a wording change on the API
    // side needs to be reflected here too.
    public static readonly suppressedValueNotes = [
        'Value cannot be calculated due to a small count',
        'Value suppressed for disclosure control due to small denominator',
        'Value suppressed for disclosure control due to small count',
    ]

}